import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import './communityButton.css';

export default class CommunityButton extends React.Component {
	static propTypes = {
		text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		icon: PropTypes.string,
		iconClass: PropTypes.string,
		children: PropTypes.element,
	};

	render() {
		const { text, icon, iconClass } = this.props;
		return (
			<div className="community-button">
				{text && <div className="column acc-font text">{text}</div>}
				<div className="column-narrow">
					<Button size="small" shape="circle">
						{this.props.children ? (
							this.props.children
						) : (
							<div className={`${icon} ${iconClass}`} />
						)}
					</Button>
				</div>
				<div className="clear" />
			</div>
		);
	}
}
